export enum CreateSurveySteps {
  Configuration,
  Settings,
  Content,
}

export const showLastModified = new Set([CreateSurveySteps.Configuration, CreateSurveySteps.Content]);
